"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileIUploadAllowExtensionDocument = exports.fileIUploadAllowExtensionImage = exports.FILE_UPLOAD_ALLOW_EXTENSION = exports.FILE_UPLOAD_FILE_CATEGORY = exports.FILE_UPLOAD_PROPERTY_INPUT_TYPE = void 0;
exports.FILE_UPLOAD_PROPERTY_INPUT_TYPE = {
    piclib: 'piclib',
};
exports.FILE_UPLOAD_FILE_CATEGORY = {
    IMAGE: 'IMAGE',
    DOCUMENT: 'DOCUMENT',
};
exports.FILE_UPLOAD_ALLOW_EXTENSION = {
    png: 'png',
    jpg: 'jpg',
    jpeg: 'jpeg',
    gif: 'gif',
    pptx: 'pptx',
    doc: 'doc',
    xls: 'xls',
    docx: 'docx',
    ppt: 'ppt',
    pdf: 'pdf',
    xlsx: 'xlsx',
};
exports.fileIUploadAllowExtensionImage = [
    exports.FILE_UPLOAD_ALLOW_EXTENSION.png,
    exports.FILE_UPLOAD_ALLOW_EXTENSION.jpg,
    exports.FILE_UPLOAD_ALLOW_EXTENSION.jpeg,
    exports.FILE_UPLOAD_ALLOW_EXTENSION.gif,
];
exports.fileIUploadAllowExtensionDocument = [
    exports.FILE_UPLOAD_ALLOW_EXTENSION.pptx,
    exports.FILE_UPLOAD_ALLOW_EXTENSION.doc,
    exports.FILE_UPLOAD_ALLOW_EXTENSION.xls,
    exports.FILE_UPLOAD_ALLOW_EXTENSION.docx,
    exports.FILE_UPLOAD_ALLOW_EXTENSION.ppt,
    exports.FILE_UPLOAD_ALLOW_EXTENSION.pdf,
    exports.FILE_UPLOAD_ALLOW_EXTENSION.xlsx,
];
